import React = require("react");
import Slider from "react-slick";
import { Link } from "../../library/link";
import { Loader } from "../../loader";
import { setCustomArrowsFocus } from "../../quick_links";
import { scrollAdviceIntoView } from "../Advice/Advice";
import { InspirationBaseSelector, inspirationLabelsWeb } from "../Shared/InspirationBaseSelector";
import { InspirationWrapper } from "../Shared/InspirationWrapperWeb";
import { MoodBasedInspirationLayoutProps } from "./MoodBasedInspirationState";

export const MoodBasedInspirationLayoutWeb = (props: MoodBasedInspirationLayoutProps) => {
  const { moodGroups, collectionPage, pushDataLayer, routePath } = props

  return (
    <div className="inspiration-page ip ip--mood-based-inspiration" key="MoodBasedInspirationLayout">
      {collectionPage.kind != "loaded" ? <Loader /> :
        <InspirationWrapper 
          {...{ ...collectionPage.value, pageTitle: `${collectionPage.value.pageTitle} - Sfeer en emotie` }}
        >
          <div className={"ip__content"}>
            <div className="container--m">
              <h2 className="ip__title title--l">Inspiratie nodig?</h2>
              <p className="ip_description description--l">
                Heb je hulp nodig met het ontdekken van je volgende boek? Kijk dan hieronder. 
                Klik op een boek dat je leuk lijkt en reserveer het direct bij jouw bibliotheek.
              </p>
              <InspirationBaseSelector activeBase="mood" routePath={routePath} labels={inspirationLabelsWeb} />
              {moodGroups.kind != 'loaded' ? <Loader /> :
                <div className="layout">
                  <div className="layout__content">
                    <div className="layout__group group__list">
                      <div className="group__list-inner">
                        {moodGroups.value.map(moodGroup => (
                          <div className="group__list-item list-item">
                            <div className="list-item__title title--m">{moodGroup.id}</div>
                            <div className="list-item__content">
                              <div className="list-item__group list-item__group-slider">
                                <Slider {... {
                                  accessibility: true,
                                  dots: true,
                                  arrows: true,
                                  infinite: false,
                                  variableWidth: true,
                                  className: "bookslider bookslider--mood",
                                  dotsClass: "bookslider-dots",
                                  speed: 500,
                                  swipeToSlide: true,
                                  slidesToScroll: 4,
                                  slidesToShow: 4,
                                  responsive: [
                                    {
                                      breakpoint: 1041,
                                      settings: {
                                        slidesToScroll: 3,
                                        slidesToShow: 3,
                                      }
                                    },
                                    {
                                      breakpoint: 793,
                                      settings: {
                                        slidesToScroll: 2,
                                        slidesToShow: 2,
                                      }
                                    },
                                    {
                                      breakpoint: 545,
                                      settings: {
                                        slidesToScroll: 1,
                                        slidesToShow: 1,
                                      }
                                    }
                                  ],
                                  onReInit: () => {
                                    const slides = document.querySelectorAll('.slick-slide');
                                    slides.forEach((slide) => {
                                      slide.setAttribute('aria-hidden', 'false')
                                    })
                                    setCustomArrowsFocus()
                                    const dots = document.querySelectorAll('.bookslider-dots li');
                                    if(dots == null || dots.length == 0) { return; }
                                    dots.forEach((dot, key) => {
                                      if(dot.classList.contains('slick-active')) { dot.setAttribute('aria-current', 'true')}
                                      else { dot.removeAttribute('aria-current') }
                                    })
                                  },
                                  slickPrev: () => {
                                    setCustomArrowsFocus()
                                  },
                                  slickNext: () => {
                                    setCustomArrowsFocus()
                                  },          
                                  customPaging: (i) => (
                                    <button tabIndex={-1}>
                                      <span className="sr-txt">Navigeer naar pagina {i + 1} van carousel</span>
                                      <span aria-hidden="true">{i + 1}</span>
                                    </button>
                                  )
                                }}>
                                  {moodGroup.moods.map((mood) =>
                                    <Link
                                      key={`mood-${mood}`}
                                      className="slider__item-link"
                                      handle={() => {
                                        pushDataLayer(moodGroup.id, mood.mood);
                                        scrollAdviceIntoView();
                                      }}
                                      url={`/${routePath}/stemming/${mood.mood}`}
                                    >
                                      <span className="slider__name">{mood.mood}</span>
                                      <div className="slider__visual">
                                        <div className="slider__visual-visuals">
                                          {mood.covers.length > 0 ?
                                            mood.covers.map((x) => <img className="slider__image" src={`${x ? x : "/book-foto.png"}`} width="105" height="150" alt={"foto van de boek"} />) :
                                            <>
                                              <img className="slider__image" src="/book-foto.png" width="105" height="150" alt={"foto van de boek"} />
                                              <img className="slider__image" src="/book-foto.png" width="105" height="150" alt={"foto van de boek"} />
                                              <img className="slider__image" src="/book-foto.png" width="105" height="150" alt={"foto van de boek"} />
                                              <img className="slider__image" src="/book-foto.png" width="105" height="150" alt={"foto van de boek"} />
                                            </>
                                          }
                                        </div>
                                      </div>
                                    </Link>
                                  )}
                                </Slider>
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              }
            </div>
          </div>
        </InspirationWrapper>
      }
    </div>)
}
